import { CFTranslatorUtil } from '@shared/utils/code-feature-translation/CFTranslator.util';
import { IconMap } from '../icons';
import {
  IRouteGroupStructure,
  IRouteStructure,
} from '@shared/common/routing/IRouteStructure';

export class ClinicianDashboardRoutes {
  public static DASHBOARD_PREFIX = 'cn';

  public static HOME: IRouteGroupStructure = {
    PREFIX: '',
    view: {
      type: 'url',
      localPath: '',
      fullUrl: `/${ClinicianDashboardRoutes.DASHBOARD_PREFIX}`,
      localeKey: 'MyDay',
      icon: IconMap.home,
    },
  };

  public static APPOINTMENTS: IRouteGroupStructure = {
    PREFIX: 'appointments',
    view: {
      type: 'url',
      localPath: '',
      fullUrl: `/${ClinicianDashboardRoutes.DASHBOARD_PREFIX}/appointments`,
      localeKey: 'Appointments',
      icon: IconMap.calendar,
    },
  };

  public static EVENT_BUILDER: IRouteGroupStructure = {
    PREFIX: CFTranslatorUtil.EventBuilder.snakeCase,
    view: {
      type: 'url',
      localPath: '',
      fullUrl: `/${ClinicianDashboardRoutes.DASHBOARD_PREFIX}/${CFTranslatorUtil.EventBuilder.snakeCase}`,
      localeKey: CFTranslatorUtil.EventBuilder.default,
      icon: IconMap.medicalBag, // todo replace this once the icon is designed
    },
  };

  public static PRESCRIPTIONS: IRouteGroupStructure = {
    PREFIX: CFTranslatorUtil.Prescriptions.snakeCase,
    view: {
      type: 'url',
      localPath: '',
      fullUrl: `/${ClinicianDashboardRoutes.DASHBOARD_PREFIX}/${CFTranslatorUtil.Prescriptions.snakeCase}`,
      localeKey: CFTranslatorUtil.Builder.default,
      icon: IconMap.builder,
    },
    edit: {
      type: 'url',
      localPath: 'edit/:prescriptionId',
      fullUrl: (id: string) =>
        `/${ClinicianDashboardRoutes.DASHBOARD_PREFIX}/${CFTranslatorUtil.Prescriptions.snakeCase}/edit/${id}`,
      localeKey: CFTranslatorUtil.Builder.default,
      icon: IconMap.builder, // todo replace this once the icon is designed
    },
  };

  public static PRESCRIPTIONS_ADMIN: IRouteGroupStructure = {
    PREFIX: `${CFTranslatorUtil.Prescriptions.snakeCase}/admin`,
    edit: {
      type: 'url',
      localPath: 'admin/edit/:prescriptionId',
      fullUrl: (id: string) =>
        `/${ClinicianDashboardRoutes.DASHBOARD_PREFIX}/${CFTranslatorUtil.Prescriptions.snakeCase}/admin/edit/${id}`,
      localeKey: CFTranslatorUtil.Prescriptions.default,
      icon: IconMap.builder,
    },
  };

  public static FORMS: IRouteGroupStructure = {
    PREFIX: CFTranslatorUtil.Forms.snakeCase,
    view: {
      type: 'url',
      localPath: '',
      fullUrl: `/${ClinicianDashboardRoutes.DASHBOARD_PREFIX}/${CFTranslatorUtil.Forms.snakeCase}`,
      localeKey: CFTranslatorUtil.Forms.default,
      translationDefault: 'Forms',
      icon: IconMap.documentEdit,
    },
    edit: {
      type: 'url',
      localPath: ':id',
      fullUrl: (id: string) => `/${ClinicianDashboardRoutes.DASHBOARD_PREFIX}/${CFTranslatorUtil.Forms.snakeCase}/${id}`,
      localeKey: CFTranslatorUtil.Forms.default,
      icon: IconMap.documentEdit,
    },
    new: {
      type: 'url',
      localPath: 'new',
      fullUrl: `/${ClinicianDashboardRoutes.DASHBOARD_PREFIX}/${CFTranslatorUtil.Forms.snakeCase}/new`,
      localeKey: CFTranslatorUtil.Forms.default,
      icon: IconMap.pencil,
    },
  };

  public static USER_ADMIN: IRouteGroupStructure = {
    PREFIX: CFTranslatorUtil.UserAdmin.snakeCase,
    list: {
      type: 'url',
      localPath: '',
      fullUrl: `/${ClinicianDashboardRoutes.DASHBOARD_PREFIX}/${CFTranslatorUtil.UserAdmin.snakeCase}`,
      localeKey: CFTranslatorUtil.UserAdmin.default,
      translationDefault: 'Users',
      icon: IconMap.accountGroupOutline,
    },
    view: {
      type: 'url',
      localPath: ':id',
      fullUrl: (id: string) => `/${ClinicianDashboardRoutes.DASHBOARD_PREFIX}/${CFTranslatorUtil.UserAdmin.snakeCase}/${id}`,
      localeKey: CFTranslatorUtil.UserAdmin.default,
      translationDefault: 'Users',
      icon: IconMap.documentEdit,
    },
    new: {
      type: 'url',
      localPath: 'new',
      fullUrl: `/${ClinicianDashboardRoutes.DASHBOARD_PREFIX}/${CFTranslatorUtil.UserAdmin.snakeCase}/new`,
      localeKey: CFTranslatorUtil.UserAdmin.default,
      icon: IconMap.documentEdit,
    },
  };

  public static PATIENTS: IRouteGroupStructure = {
    PREFIX: 'patients',
    list: {
      type: 'url',
      localPath: '',
      fullUrl: `/${ClinicianDashboardRoutes.DASHBOARD_PREFIX}/patients`,
      localeKey: 'Patients',
      icon: IconMap.accountGroupOutline, // todo replace this once the icon is designed
    },
    new: {
      type: 'url',
      localPath: 'new',
      fullUrl: `/${ClinicianDashboardRoutes.DASHBOARD_PREFIX}/patients/new`,
    },
    view: {
      type: 'url',
      localPath: 'view',
      fullUrl: `/${ClinicianDashboardRoutes.DASHBOARD_PREFIX}/patients/view`,
    },
  };

  public static ACCOUNT_SETTINGS: IRouteGroupStructure = {
    PREFIX: 'account-settings',
    view: {
      type: 'url',
      localPath: '',
      fullUrl: `/${ClinicianDashboardRoutes.DASHBOARD_PREFIX}/account-settings`,
      localeKey: 'ProfileSlashSettings',
      icon: IconMap.settings,
    },
  };
}
